<!--LOADING SPINNER-->
<div class="spinner">
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <span class="loading-message">Loading...</span>
  </div>
</div>
<!--END LOADING SPINNER-->
